import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { throwError } from "rxjs";
import { RoutingPath } from "src/app/configs/routing-path";

@Injectable({
  providedIn: 'root'
})
export class HandleErrorHttpService {

  constructor( private router: Router) { }

  errorHandle(error: HttpErrorResponse) {

    return throwError(() => 'Se ha presentado un inconveniente con tu solicitud debes intentar mas tarde.');

  }


}
